// Grille publique : les montants commerciaux sont centralisés ici, hors calcul du moteur.
export const TARIFS_PUBLICS = {
  diagnostic: '3 500 € HT', abonnement: 'à partir de 290 € HT par mois',
  diagnosticDedie: '4 900 € HT, mise en service comprise', abonnementDedie: 'à partir de 690 € HT par mois',
  outils: '150 € HT par mois', lancement: 'environ 1 500 € HT',
} as const;

export const ETATS_COMPTE: Record<string, { titre: string; action: string }> = {
  en_attente_courriel: { titre: 'En attente du courriel', action: 'Ouvrez le lien reçu par courriel pour poursuivre.' },
  en_attente_paiement: { titre: 'En attente de paiement', action: 'Relisez les conditions puis poursuivez le paiement si celui-ci est proposé.' },
  actif: { titre: 'Actif', action: 'Votre compte est payé. Le contrôle humain d’Ekera reste nécessaire avant tout accès aux sources, au collecteur, aux écritures et au partage.' },
  verifie: { titre: 'Vérifié', action: 'Le contrôle humain est terminé. Connectez-vous pour accéder aux fonctions autorisées.' },
  suspendu: { titre: 'Suspendu', action: 'Contactez Ekera ou consultez votre facturation pour régulariser la situation. Aucune donnée n’est effacée par cette suspension.' },
  migration: { titre: 'En migration', action: 'Votre espace change d’hébergement. Attendez la fin de l’opération et actualisez cet état.' },
  resilie: { titre: 'Résilié', action: 'Contactez Ekera pour la réversibilité et l’attestation d’effacement prévue au contrat.' },
  efface: { titre: 'Effacé', action: 'Contactez Ekera pour votre attestation d’effacement.' },
};

const REFUS: Record<string, string> = {
  courriel_invalide: 'Vérifiez le format de votre adresse de courriel.',
  courriel_non_professionnel: 'Utilisez votre adresse de courriel professionnel.',
  siren_invalide: 'Vérifiez les neuf chiffres du SIREN.', siren_inconnu: 'Ce SIREN n’est pas reconnu par l’annuaire.',
  entreprise_cessee: 'L’annuaire indique que cette entreprise a cessé son activité.',
  nom_invalide: 'Indiquez votre nom (de 2 à 200 caractères).',
  offre_invalide: 'Choisissez une offre proposée.', pouvoir_requis: 'Confirmez votre pouvoir d’engager l’entreprise.',
  defi_invalide: 'Le contrôle anti-abus a expiré ou a déjà servi. Recommencez la demande.',
  trop_de_demandes: 'Trop de demandes. Patientez avant de réessayer.',
  jeton_invalide: 'Ce lien est invalide, expiré ou déjà utilisé. Refaites une demande d’inscription.',
  session_invalide: 'La session d’inscription est absente ou expirée. Refaites une demande pour recevoir un nouveau lien.',
  non_authentifie: 'Reconnectez-vous pour consulter votre facturation.',
  conditions_incompletes: 'Lisez et acceptez les trois documents.', conditions_requises: 'Acceptez les conditions avant de payer.',
  version_perimee: 'Les conditions ont changé. Rechargez les textes et relisez-les avant de les accepter.',
  etat_incompatible: 'Cette action n’est pas disponible dans l’état actuel du compte. Actualisez son état.',
  deja_paye: 'Le paiement est déjà confirmé. Actualisez l’état du compte.',
  paiement_indisponible: 'Le service de paiement est indisponible. Réessayez plus tard.',
  paiement_desactive: 'Le paiement en ligne n’est pas disponible. Contactez Ekera pour le paiement sur facture.',
  portail_indisponible: 'Le portail de facturation n’est pas disponible.',
  aucun_abonnement: 'Aucun abonnement en ligne n’est associé à cette entreprise.',
  role_insuffisant: 'La facturation est réservée à l’administrateur de l’entreprise.',
  annuaire_indisponible: 'Le contrôle du SIREN est indisponible. Réessayez plus tard.',
  courriel_indisponible: 'Le courriel n’a pas pu partir. Réessayez dans quelques minutes.',
  registre_occupe: 'Le service est occupé. Réessayez plus tard.', indisponible: 'Le service est indisponible. Réessayez plus tard.',
};
export function refusInscription(code: string): string {
  return REFUS[code] ?? 'La demande n’a pas abouti. Vérifiez les champs ou réessayez plus tard.';
}

export function adresseStripe(url: string, service: 'checkout' | 'billing'): string {
  const prefixe = `https://${service}.stripe.com/`;
  if (!url.startsWith(prefixe) || /[\s\\]/.test(url)) throw new Error('Adresse de paiement refusée. Contactez Ekera.');
  const u = new URL(url);
  if (u.origin !== `https://${service}.stripe.com` || u.username || u.password) throw new Error('Adresse de paiement refusée. Contactez Ekera.');
  return url;
}

/** Le lien SS6 utilise un fragment #jeton= ; aucun jeton n'est conservé dans l'adresse. */
export function retirerJeton(url: URL, remplacer: (adresse: string) => void): string | null {
  const fragment = url.hash.slice(1);
  const q = fragment.includes('?') ? fragment.slice(fragment.indexOf('?') + 1) : fragment;
  const jeton = new URLSearchParams(q).get('jeton') ?? url.searchParams.get('jeton');
  if (jeton !== null) remplacer(`${url.pathname}#/inscription/verification`);
  return jeton;
}
